<script setup lang="ts">
// ================================
// IMPORTS
// ================================
// Aucun import : placeholder de route uniquement.

// ================================
// ROUTE FALLBACK
// ================================
/**
 * Placeholder pour la route nommée `Home` lorsque la navigation reste sur `/`.
 */
</script>

<template>
    <!-- ================================ -->
    <!-- PLACEHOLDER (non visible) -->
    <!-- ================================ -->
    <div class="home-route-fallback hidden" aria-hidden="true" />
</template>
